import { render, staticRenderFns } from "./flow-choice.vue?vue&type=template&id=44a278c7&"
import script from "./flow-choice.vue?vue&type=script&lang=js&"
export * from "./flow-choice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a278c7')) {
      api.createRecord('44a278c7', component.options)
    } else {
      api.reload('44a278c7', component.options)
    }
    module.hot.accept("./flow-choice.vue?vue&type=template&id=44a278c7&", function () {
      api.rerender('44a278c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/components/templates/flow-choice.vue"
export default component.exports